import {
  getChainContracts,
  resolveChainID,
} from "@/shared/config/blockchain/helpers";
import { Blockchain } from "@/shared/config/blockchain/types";

export const getExchangeDomainData = (blockchain: Blockchain) => {
  const chainId = resolveChainID(blockchain);

  const contracts = getChainContracts(chainId);

  return {
    name: "Endemic Exchange",
    version: "1",
    chainId: chainId,
    verifyingContract: contracts?.exchangeAddress.toLowerCase(),
    salt: "0x131484dcb16b672db098e987e2fba2f72539f5d46e862a37ad73acbaf1a6ce78",
  };
};

export const getArtOrderDomainData = (blockchain: Blockchain) => {
  const chainId = resolveChainID(blockchain);

  const contracts = getChainContracts(chainId);

  return {
    name: "ArtOrder",
    version: "1",
    chainId: chainId,
    verifyingContract: contracts?.artOrderAddress.toLowerCase(),
  };
};
